import React, { useEffect, useState } from 'react';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import TestimonialImage1 from '../assets/images/testimonial1.jpg';
import TestimonialImage2 from '../assets/images/testimonial2.jpg';
import TestimonialImage3 from '../assets/images/testimonial3.jpg';
import TestimonialImage4 from '../assets/images/testimonial4.jpg';
import TestimonialImage5 from '../assets/images/testimonial5.jpg';

const testimonials = [
    {
        id: 1,
        image: TestimonialImage1,
        name: "Queen Mary University of London",
        role: "MSc Artificial Intelligence with Distinction",
        feedback: "Rastra successfully completed his Master of Science in Artificial Intelligence with Distinction. His thesis focused on developing an AI-powered oral health diagnostic system that could potentially reduce clinical costs and improve early detection of dental conditions. Throughout his time at Queen Mary, he showed a strong grasp of computer vision, deep learning, and practical problem-solving. His research demonstrated not just technical skill but also a genuine interest in using AI for real-world healthcare applications. We're confident he'll continue to make meaningful contributions in the field of artificial intelligence.",
        buttonText: "View Certificate",
        buttonType: "pdf",
        file: "/assets/pdf/Queen Mary Degree Award.pdf"
    },
    {
        id: 2,
        image: TestimonialImage2,
        name: "Bikashsoft Technology Pvt. Ltd.",
        role: "Freelance Software Developer since July 2017",
        feedback: "Rastra has been an invaluable freelancer at Bikashsoft Technology since July 2017. Over the years, he has worked on multiple projects involving website development, backend supervision, data analysis, and debugging. What stood out most was his ability to consistently deliver ahead of deadlines while maintaining high-quality work. He's proficient with the latest tools and technologies and always eager to learn more. Beyond our current offerings, he's shown a strong aptitude for AI and machine learning, with a solid understanding of multiple programming languages. It's been a pleasure working with him, and I'd happily recommend him for any future opportunities.",
        buttonText: "View Work Experience Letter",
        buttonType: "pdf",
        file: "/assets/pdf/Work Experience Letter.pdf"
    },
    {
        id: 3,
        image: TestimonialImage4,
        name: "Softwarica College & Coventry University",
        role: "Certificate of Excellence 2023 - Best Award",
        feedback: "We're proud to present this Certificate of Excellence to Rastra Dhoj Karki, who graduated from Softwarica College in collaboration with Coventry University. During his time here, Rastra went beyond academics by writing insightful articles for The Rising Nepal, one of Nepal's leading English newspapers. His curiosity and dedication extended well past the classroom, and he was always willing to take on new challenges. This Best Award for 2023 recognizes not just his academic achievements but also his active involvement in the college community. He's exactly the kind of student who makes teaching rewarding.",
        buttonText: "View Excellence Certificate",
        buttonType: "pdf",
        file: "/assets/pdf/Softwarica Excellence Certificate.pdf"
    },
    {
        id: 4,
        image: TestimonialImage5,
        name: "Nepal-Bharat Maitri Hospital",
        role: "Certificate of Appreciation - Volunteer Coordinator",
        feedback: "This certificate recognizes Rastra Dhoj Karki for his remarkable dedication as a volunteer coordinator at our healthcare camps since 2017. Over the years, he has helped organize medical camps that brought essential healthcare services to underserved communities across Nepal. His work in volunteer management and logistics coordination made a real difference in how smoothly our camps ran. Rastra's commitment to community service reflects his genuine desire to help others. We're grateful for his selfless contributions and consider him an integral part of our mission to provide quality healthcare to those who need it most.",
        buttonText: "View Certificate",
        buttonType: "pdf",
        file: "/assets/pdf/Nepal-Bharat Maitri Hospital Certificate.pdf"
    },
    {
        id: 5,
        image: TestimonialImage3,
        name: "Kishore Bahadur Karki",
        role: "Father and Lifelong Supporter",
        feedback: "Watching Rastra grow from a curious kid who loved tinkering with computers to a skilled AI engineer has been one of my greatest joys as a father. I've seen him stay up late debugging code, work through tough problems, and never give up even when things got hard. When he earned his Distinction from Queen Mary University, our whole family celebrated. He's always been humble, always eager to learn something new. I know this is just the start for him. Whatever he chooses to do next, I have no doubt he'll put his heart into it and make us all proud.",
        buttonText: "Send Cheers",
        buttonType: "celebration"
    }
];

function Testimonial() {
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalFile, setModalFile] = useState('');
    const [showCelebration, setShowCelebration] = useState(false);

    useEffect(() => {
        const swiper = new Swiper(".mySwiper", {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 50,
            loop: true,
            grabCursor: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        return () => {
            if (swiper) swiper.destroy();
        };
    }, []);

    const openModal = (title, file) => {
        setModalTitle(title);
        setModalFile(file);
        setShowModal(true);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setShowModal(false);
        setModalFile('');
        setModalTitle('');
        document.body.style.overflow = 'auto';
    };

    const triggerCelebration = () => {
        setShowCelebration(true);
        createConfetti();
        
        setTimeout(() => {
            setShowCelebration(false);
            const confettiContainer = document.querySelector('.confetti-container');
            if (confettiContainer) {
                confettiContainer.innerHTML = '';
            }
        }, 4000);
    };

    const createConfetti = () => {
        const container = document.querySelector('.confetti-container');
        if (!container) return;

        const colors = ['#4169E1', '#6B8DE8', '#FFD700', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD', '#98D8C8'];
        const shapes = ['square', 'circle', 'triangle'];
        
        for (let i = 0; i < 150; i++) {
            const confetti = document.createElement('div');
            confetti.className = `confetti ${shapes[Math.floor(Math.random() * shapes.length)]}`;
            confetti.style.left = Math.random() * 100 + '%';
            confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
            confetti.style.animationDelay = Math.random() * 2 + 's';
            confetti.style.animationDuration = (Math.random() * 2 + 2) + 's';
            container.appendChild(confetti);
        }
    };

    const handleButtonClick = (testimonial) => {
        if (testimonial.buttonType === 'pdf') {
            openModal(testimonial.name, testimonial.file);
        } else if (testimonial.buttonType === 'celebration') {
            triggerCelebration();
        }
    };

    return (
        <div className={`testimonial-container ${showCelebration ? 'celebrating' : ''}`}>
            <div className="confetti-container"></div>
            
            <h2 className="heading">Credentials and <span>Testimonials</span></h2>
            <p style={{ 
                textAlign: 'center', 
                fontSize: '1.6rem', 
                marginBottom: '2rem',
                maxWidth: '60rem',
                margin: '0 auto 2rem'
            }}>
                Recognition from academic institutions, professional experience, and the support that made it all possible.
            </p>
            <div className="testimonial-wrapper">
                <div className="testimonial-box mySwiper">
                    <div className="testimonial-content swiper-wrapper">
                        {testimonials.map((testimonial) => (
                            <div className="testimonial-slide swiper-slide" key={testimonial.id}>
                                <img 
                                    src={testimonial.image} 
                                    alt={testimonial.name} 
                                    loading="lazy"
                                />
                                <h3>{testimonial.name}</h3>
                                <span style={{
                                    fontSize: '1.4rem',
                                    color: 'var(--main-color)',
                                    fontWeight: '500',
                                    display: 'block',
                                    marginBottom: '1.5rem'
                                }}>
                                    {testimonial.role}
                                </span>
                                <p>{testimonial.feedback}</p>
                                <button 
                                    className={`testimonial-btn ${testimonial.buttonType === 'celebration' ? 'celebration-btn' : ''}`}
                                    onClick={() => handleButtonClick(testimonial)}
                                    aria-label={testimonial.buttonText}
                                >
                                    {testimonial.buttonType === 'pdf' && (
                                        <i className='bx bx-file'></i>
                                    )}
                                    {testimonial.buttonType === 'celebration' && (
                                        <i className='bx bx-party'></i>
                                    )}
                                    {testimonial.buttonText}
                                </button>
                            </div>
                        ))}
                    </div>
                    <div className="swiper-button-next" aria-label="Next testimonial"></div>
                    <div className="swiper-button-prev" aria-label="Previous testimonial"></div>
                    <div className="swiper-pagination"></div>
                </div>
            </div>

            <div 
                className={`testimonial-modal ${showModal ? 'active' : ''}`}
                onClick={closeModal}
            >
                <div className="testimonial-modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="testimonial-modal-header">
                        <h3>{modalTitle}</h3>
                        <button 
                            className="testimonial-modal-close" 
                            onClick={closeModal}
                            aria-label="Close modal"
                        >
                            <i className='bx bx-x'></i>
                        </button>
                    </div>
                    <div className="testimonial-modal-body">
                        {modalFile && (
                            <iframe 
                                src={modalFile}
                                title="Document Preview"
                                loading="lazy"
                            />
                        )}
                    </div>
                </div>
            </div>

            {showCelebration && (
                <div className="celebration-overlay">
                    <div className="celebration-message">
                        <i className='bx bx-heart'></i>
                        <h3>Thank You Dad!</h3>
                        <p>Your support means everything! 🎉</p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Testimonial;